import {Vue} from '~/addiesaas'
import Login from './Login'

Vue.component(Login.name, Login)

export default {Login}
